import React from "react";
import {Outlet} from "react-router-dom";
import Sidebar from "../component/sidebar";
import Header from "../component/header";
import {useSelector} from "react-redux";
import {RootState} from "../store/store";

import "../App.scss";
const Private = () => {
	const isloading = useSelector((state: RootState) => state.filter.loader);
	return (
		<div>
			<Sidebar />
			<Header />
			<main className="main-layuot">
				{isloading === true ? <h2>loading...</h2> : <Outlet />}
			</main>
		</div>
	);
};

export default Private;
